<template>
  <div class="">
      <!-- HEAD -->

      <div class="head row p-0 g-0">
          <div class="col-12 p-0"  data-aos="fade-down" data-aos-easing="ease-out-cubic" data-aos-duration="500">
              <img :src="`${publicPath}img/RG_header.jpg`" class="img-responsive">
          </div>
      </div>

      <!-- end HEAD -->
      <div class="presentacion"  data-aos="fade" data-aos-delay="250" data-aos-easing="linear" data-aos-duration="1000">
          <div class="row g-0">
              <div class="col-12 col-xl-11 col-xxl-10 m-auto p-3 pt-0 text-start">
                  <div class="row">

                      <div class="col-12 overflowMobil text-center">
                            <h2 class="pt-5 pb-0" data-aos="fade" data-aos-easing="linear" data-aos-duration="1000">{{ $t('resumen.2021-en-resumen') }}</h2>
                            <hr>
                            <h3 class="pt-5" data-aos="fade" data-aos-easing="linear" data-aos-duration="1000">{{ $t('resumen.cifra-de-negocios') }}</h3>
                            <hr>
                      </div>
                      <div class="col-12 col-xl-7 col-xxl-8">
                            <div class="p-0 pt-3 align-middle" data-aos="fade-right" data-aos-easing="linear" data-aos-duration="500">
                                <intersection-observer
                                  sentinal-name="sentinal-bars-chart"
                                  @on-intersection-element="toogleBarsChart"
                                >
                                  <animated-bars  v-if="BarsIsOnViewport" :height="100" />
                                </intersection-observer>
                                <p align="right" class="llegenda">{{ $t('resumen.en-millones-eur') }}</p>
                            </div>
                      </div>
                      <div class="col-12 col-xl-5 col-xxl-4">
                            <div class="p-3 pt-0 text-start align-bottom" data-aos-id="start-counter-resumen" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="500">
                                <h3 style="font-size: 60px">

                                    <AnimatedNumber
                                        ref='counter'
                                        :startAmount='0'
                                        :endAmount='2053'
                                        :duration='2'
                                        prefix=''
                                        suffix=''
                                        :separator=separator
                                        decimalSeparator=','
                                        :decimals='0'
                                        :autoinit='true'
                                    />

                                 <span style="font-size: 30%;">&nbsp;M €</span>

                                </h3>
                                <p class="destacat text-turquesa">{{ $t('resumen.mejor-cifra-de-ventas-de-la-historia-del-grupo') }}</p>
                                <p>{{ $t('resumen.roca-group-supera-por-primera-vez') }}</p>
                                <hr>
                                <!--
                                    <animated-circle />
                                    <img :src="`${publicPath}img/RG_graf2.gif`" class="img-responsive">
                                -->
                            </div>
                      </div>
                  </div>
                <div class="row">
                    <div class="col-12 text-center">
                        <h3 class="pt-5" data-aos="fade" data-aos-easing="linear" data-aos-duration="1000"> {{ $t('resumen.resultados') }} </h3>
                        <hr>
                    </div>
                    <div class="col-12 col-xl-7 col-xxl-8">
                        <div class="p-0 pt-3 align-middle" data-aos="fade-right" data-aos-easing="linear" data-aos-duration="500">
                          <div class="table-responsive">
                            <table class="table table-hover tableRG">
                                <thead>
                                <tr class="topTable">
                                    <th scope="col" class="text-center align-text-bottom"></th>
                                    <th scope="col" class="text-center align-text-bottom">2018</th>
                                    <th scope="col" class="text-center align-text-bottom">2019</th>
                                    <th scope="col" class="text-center align-text-bottom">2020</th>
                                    <th scope="col" class="text-center align-text-bottom">2021</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <th scope="row" class="align-middle colTable text-start">EBITDA</th>
                                    <td class="px-0 px-lg-3 text-center align-text-bottom">243</td>
                                    <td class="px-0 px-lg-3 text-center align-text-bottom">253</td>
                                    <td class="px-0 px-lg-3 text-center align-text-bottom">306</td>
                                    <td class="px-0 px-lg-3 text-center align-text-bottom">401</td>
                                </tr>
                                <tr>
                                    <th scope="row" class="align-middle colTable text-start">{{ $t('resumen.resultado-neto') }}</th>
                                    <td class="px-0 px-lg-3 text-center align-text-bottom">95</td>
                                    <td class="px-0 px-lg-3 text-center align-text-bottom">69</td>
                                    <td class="px-0 px-lg-3 text-center align-text-bottom">60</td>
                                    <td class="px-0 px-lg-3 text-center align-text-bottom">179</td>
                                </tr>
                                <tr>
                                    <th scope="row" class="align-middle colTable text-start">{{ $t('resumen.inversiones') }}</th>
                                    <td class="px-0 px-lg-3 text-center align-text-bottom">145</td>
                                    <td class="px-0 px-lg-3 text-center align-text-bottom">154</td>
                                    <td class="px-0 px-lg-3 text-center align-text-bottom">106</td>
                                    <td class="px-0 px-lg-3 text-center align-text-bottom">124</td>
                                </tr>
                                </tbody>
                            </table>
                          </div>
                            <p align="right" class="llegenda">{{ $t('resumen.en-millones-eur') }}</p>
                        </div>
                    </div>
                    <div class="col-12 col-xl-5 col-xxl-4">
                        <div class="p-3 text-start align-bottom" data-aos-id="circle-animation" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="500">
                            <p v-html="$t('resumen.la-busqueda-continua-de-la-optimizacion-y-la-excelencia-en')"></p>
                            <hr>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 py-5 text-center">
                      <localized-link class="btnEnResumen" to="/informe-financiero">{{ $t('resumen.ver-informe-financiero') }}</localized-link>
                    </div>
                </div>
                <hr>

            </div>
          </div>
      </div>
      <div class="contingut row g-0 py-5">

          <hr>
          <div class="row">
              <div class="col-6 p-0 m-0 pb-5 ps-3 text-start">
                  <localized-link class="footerLink" to="/roca-group-2021/presentacion"><img :src="`${publicPath}img/breadcrumbBack.gif`" class="img-responsive" width="6"> {{ $t("nav.presentacion") }}</localized-link>
              </div>
              <div class="col-6 p-0 m-0 pb-3 pe-3 text-end">
                  <localized-link class="footerLink" to="/roca-group-2021/roca-group-en-el-mundo">{{ $t("nav.en-el-mundo") }} <img :src="`${publicPath}img/breadcrumbGo.gif`" class="img-responsive" width="6"></localized-link>
              </div>
          </div>
      </div>

  </div>
</template>

<script>
  /*import AnimatedCircle from '@/components/ChartCircle.vue';*/
  import AnimatedBars from '@/components/ChartBars.vue'
  import AnimatedNumber from 'vue3-autocounter'
  import IntersectionObserver from '@/components/IntersectionObserver.vue'


  export default {
    components: {
      //AnimatedCircle,
      AnimatedBars,
      AnimatedNumber,
      IntersectionObserver
    },
    data() {
        return {
            publicPath: process.env.BASE_URL,
            BarsIsOnViewport: false,
            LinesIsOnViewport: false,
            separator: '.'
        }
    },
    mounted() {
      document.addEventListener('aos:in:start-counter-resumen', this.startCounter);
      if(this.$i18n.locale=="es"){
          this.separator = '.';
      } else {
          this.separator = ',';
      }
    },
    methods: {
        startCounter() {
            this.$refs.counter.start();
        },
        toogleBarsChart(visible) {
            this.BarsIsOnViewport = visible;
        }
    }
  };
</script>
